<template>
	<div>
		<a class="bah" href="https://www.miit.gov.cn/" target="_blank">粤ICP备2022119733号-1</a>
		<div class="fotNav">
			<div class="item">
				<div @click="tiaozhuan">
					<img src="../static/icon_tab1_act.png" alt="">
					<p>主页</p>
				</div>
			</div>
			<div class="item">
				<div @click="tiaozhuan1">
					<img src="../static/icon_tab5_act.png" alt="">
					<p>我的</p>
				</div>
			</div>
		</div>
		<div class="fotNav" style="opacity: 0;position: relative;">
			<div class="item">
				<div>
					<img src="../static/icon_tab1_act.png" alt="">
					<p>主页</p>
				</div>
			</div>
			<div class="item">
				<div>
					<img src="../static/icon_tab5_act.png" alt="">
					<p>我的</p>
				</div>
			</div>
		</div>
		
	</div>
</template>
<script>
export default {
    data(){
        return{
			user_data:{}
        }
    },
	created() {
	    this.user_data = JSON.parse(localStorage.getItem('user_data'))
	},
	methods: {
		// 跳转
		tiaozhuan() {
			this.$router.push({
				path: '/'
			})
		},
		tiaozhuan1() {
			if(this.user_data){
				this.$router.push({
				    path: '/user/userhome'
				})
			}else{
				this.$message.warning(this.$t('m.MallCenter_22'))
			}
			
		},
	}
}
</script>
<style scoped lang="scss">
.bah{
	text-align: center;
	color: #fff;
	background: #ea534a;
	border: none;
	width: 100%;
	display: block;
	text-decoration:none;
}
.fotNav{
	display: none;
	padding: 0.25rem 0;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: 2;
	background: #fff;
	.item{
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		cursor: pointer;
		img{
			display: block;
			width: 0.8rem;
			margin: auto;
			margin-bottom: 0.1rem;
		}
	}
}
@media screen and (max-width: 1200px){
	.fotNav{
		display: flex;
		box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.3);
	}
}
</style>